import { RouterView } from "nx-libs";

const commonRoutes = [
  {
    path: "register-success",
    name: "ERegistrationRegisterSuccess",
    component: () => import("./views/ERegistrationRegisterSuccessView")
  },
  {
    path: "register-cps-success",
    name: "ERegistrationRegisterCPSSuccess",
    component: () => import("./views/ERegistrationRegisterCPSSuccessView")
  }
];

const publicRoutes = [
  {
    path: "public",
    component: RouterView,
    children: [
      {
        path: "term-cond",
        name: "ERegistrationPublicTermCond",
        component: () => import("./views/ERegistrationPublicTermCondView")
      },
      {
        path: "register",
        name: "ERegistrationPublicRegister",
        component: () => import("./views/ERegistrationPublicRegisterView")
      }
    ]
  }
];

const profRoutes = [
  {
    path: "prof",
    component: RouterView,
    children: [
      {
        path: "activate",
        name: "ERegistrationProfessionalActivate",
        component: () => import("./views/ERegistrationProfessionalActivateView")
      },
      {
        path: "register",
        name: "ERegistrationProfessionalRegister",
        component: () =>
          import("./views/ERegistrationProfessionalRegisterView"),
        props: true
      },
      {
        path: "login-public/register-public",
        name: "ERegistrationPublicMemberRegister",
        component: () =>
          import("./views/ERegistrationPublicMemberRegisterView"),
        props: true
      },
      {
        path: "registeriamsmarttac",
        name: "ERegistrationIAmSmartTermAndCond",
        component: () =>
          import("./views/ERegistrationIAmSmartTermAndCondView"),
        props: true
      },
      {
        path: "login-public/registeriamsmarttacpublic",
        name: "ERegistrationIAmSmartTermAndCondForPublicView",
        component: () =>
          import("./views/ERegistrationIAmSmartTermAndCondForPublicView"),
        props: true
      },
      {
        path: "upgrade",
        name: "ERegistrationProfessionalUpgrade",
        component: () =>
          import("./views/ERegistrationProfessionalUpgradeView"),
        props: true
      }
    ]
  }
];

const helperRoutes = [
  {
    path: "helper",
    component: RouterView,
    children: [
      {
        path: "register",
        name: "ERegistrationHelperRegister",
        component: () => import("./views/ERegistrationHelperRegisterView"),
        props: true
      },
      {
        path: "upgrade",
        name: "ERegistrationHelperUpgrade",
        component: () => import("./views/ERegistrationHelperUpgradeView"),
        props: (route) => ({
          invitationKey: route.query.key
        })
      }
    ]
  }
];

const ownerRoutes = [
  {
    path: "owner",
    component: RouterView,
    children: [
      {
        path: "register",
        name: "ERegistrationOwnerRegister",
        component: () => import("./views/ERegistrationOwnerRegisterView"),
        props: true
      },
      {
        path: "upgrade",
        name: "ERegistrationOwnerUpgrade",
        component: () => import("./views/ERegistrationOwnerUpgradeView"),
        props: (route) => ({
          invitationKey: route.query.key
        })
      }
    ]
  }
];

const cpsRoutes = [
  {
    path: "cps",
    component: RouterView,
    children: [
      {
        path: "register",
        name: "ERegistrationCPSRegister",
        component: () => import("./views/ERegistrationCPSRegisterView"),
        props: true
      }
    
    ]
  }
];

export default [
  {
    path: "/registration",
    component: RouterView,
    children: [
      ...commonRoutes,
      ...publicRoutes,
      ...profRoutes,
      ...helperRoutes,
      ...ownerRoutes,
      ...cpsRoutes
    ]
  }
];
